import styled from '@emotion/styled'
import type { ProductVariantOptionsType } from '@src/type/product/form'
import SkuTableItem from './SkuTableItem'
import React from 'react'

type PropsType = {
	horizOptions: ProductVariantOptionsType[]
	vertOption?: ProductVariantOptionsType
	startIndex: number
}
const SkuTableRow = ({ horizOptions, vertOption, startIndex }: PropsType) => {
	return (
		<TableRow>
			{horizOptions.map((option, index) => {
				return (
					<ItemWrapper key={`sku-item-wrapper-${option.cno}`}>
						<SkuTableItem
							horizOption={option}
							vertOption={vertOption}
							itemIndex={startIndex + index}
						/>
					</ItemWrapper>
				)
			})}
		</TableRow>
	)
}

const TableRow = styled.div`
	display: flex;
	justify-content: center;
	border-left: 1px solid;
`

const ItemWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	border-right: 1px solid;
	border-bottom: 1px solid;
	width: 27rem;
	height: 24.5rem;
`

const AlignOptionTitle = styled.div`
	width: 100%;
	min-width: 27rem;
	text-align: center;
	border-bottom: 1px solid #000;
	padding: 1rem 0;
	font-size: 1.2rem;
	font-weight: 500;
`

const VertOptionTitle = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	border-right: 1px solid;
	border-bottom: 1px solid;
	max-width: 8rem;
	width: 8rem;
	word-break: break-all;
	font-size: 1.2rem;
	font-weight: 500;
	padding: 0 1rem;
`

export default SkuTableRow
